import Logo from "@/components/Header/Logo";
import "@/pages/Privacy/Privacy.css";

// --------------------------------------------------------------------------------------

export default function Terms() {
	// The date should be updated manually when the policy changes
	const lastUpdatedDate = "June 18, 2025";

	// --------------------------------------------------------------------------------------

	return (
		<>
			{/* Page head */}
			<title>BrainEm ￭ Terms of Service</title>
			<meta
				name="description"
				content="This page details the Terms of Service for brainem.co, covering i.a. acceptable use, intellectual property, contributions, privacy, and liability limitations."
			/>

			{/* ------------------------------------------------------------------------------ */}

			{/* Page content */}
			<div className="privacy-wrapper">
				<header>
					<Logo />
				</header>

				{/* Hero heading */}
				<div className="privacy-heading">
					<h1>Terms of Service</h1>
					<p>Last Updated: {lastUpdatedDate}</p>
				</div>

				{/* ------------------------------------------------------------------------------ */}

				{/* Sections */}
				<main className="privacy-main">
					<section>
						<p>
							By accessing or using this website, you acknowledge that you agree
							to be bound by these Terms of Service.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Acceptable Use</h2>
						<p>
							Please use this site responsibly and for lawful purposes only.
							Activities that could harm the service or other users are
							prohibited.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Intellectual Property</h2>
						<p>
							Unless stated otherwise, all textual content and source code on
							this site are © brainem.co. Icons, photographs, and other visual
							assets remain the property of their respective creators and are
							used here under license or with permission. You are welcome to
							link to publicly accessible pages, but you may not reproduce,
							distribute, or otherwise exploit any materials without obtaining
							the appropriate permissions.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Contributions & Refunds</h2>
						<p>
							All contributions are processed securely through Stripe. Payment
							details are handled by Stripe and are subject to its own{" "}
							<a
								href="https://stripe.com/privacy"
								target="_blank"
								rel="noopener noreferrer"
							>
								privacy policy
							</a>
							. <strong>NOTE:</strong> Voluntary contributions to brainem.co are
							currently NOT tax-deductible, and do not qualify as charitable
							donations.
						</p>
						<p>
							Contributions under the "Spike" tier are voluntary donations that
							fuel open-source research and tooling. Because no specific goods
							or services are promised, these donations are non-refundable.
						</p>
						<p>
							"Medici"-tier sponsorships (USD 10,000 and above) may be covered
							by a mutually agreed statement of work. If brainem.co does not
							fulfil the agreed deliverables, you may request a full or
							pro-rated refund for the undelivered portion of the work. Approved
							refunds are processed to the original payment method via Stripe;
							bank processing times may vary.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Calculator Results</h2>
						<p>
							The calculator is provided for informational purposes only. It
							does not constitute medical, financial, or other professional
							advice. Always consult a qualified professional before acting on
							the results.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>No Warranty &amp; Limitation of Liability</h2>
						<p>
							This site and its contents are provided "as is" without any
							warranty. To the fullest extent permitted by law, we disclaim all
							liability for damages arising from your use of the service.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Indemnification</h2>
						<p>
							You agree to indemnify, defend, and hold harmless the site owner
							from any claims, liabilities, and expenses arising from your use
							of the service or violation of these Terms.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Governing Law &amp; Jurisdiction</h2>
						<p>
							These Terms are governed by the laws of the Czech Republic. Any
							disputes will be resolved exclusively in the courts of the Czech
							Republic.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Privacy &amp; Data Storage</h2>
						<p>
							Brainem.co is designed to minimize data collection. We do not
							request personal information, set advertising cookies, or track
							individuals. Cloudflare Web Analytics provides only anonymous,
							aggregate metrics, and its security features may temporarily
							process technical data such as your IP address. Error monitoring
							via Sentry runs only outside the EEA/EFTA with IP addresses
							redacted. Calculator settings remain on your device; shareable
							scenarios are stored in Cloudflare KV for up to ten years and
							contain no personal data. See our{" "}
							<a href="/privacy">Privacy Policy</a> for full details.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Service Discontinuation</h2>
						<p>
							If the service is discontinued, migrated, or otherwise shut down,
							any stored scenarios may be deleted before the stated ten-year
							retention period expires.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Third-Party Links</h2>
						<p>
							Links to external websites are provided for convenience. We do not
							control those sites and are not responsible for their content or
							practices.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Modifications &amp; Effective Date</h2>
						<p>
							We may modify these Terms at any time. The "Last Updated" date at
							the top of this page indicates when the current version became
							effective.
						</p>
					</section>

					{/* ------------------------------------------------------------------------------ */}

					<section>
						<h2>Contact</h2>
						<p>
							For questions regarding these Terms, or any other matter related
							to brainem.co, please email{" "}
							<a href="mailto:dave@dnarna.co" className="email-link">
								dave@dnarna.co
							</a>
							.
						</p>
					</section>
				</main>
			</div>
		</>
	);
}
